module.exports = __webpack_public_path__ + "img/success.62e23812.png";